import { Button } from "@msuite/ui/button";
import { Divider } from "@msuite/ui/divider";
import { FormSwitch, TextInput, TextInputAddTrigger } from "@msuite/ui/form";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import type { PartnerSendReportFormSchema } from "@msuite/utils/schemas";
import React from "react";
import { useFormContext, useWatch } from "react-hook-form";

export function PartnerSendReportForm() {
	/** Context */
	const methods = useFormContext<PartnerSendReportFormSchema>();
	const recipients = useWatch({ control: methods.control, name: "recipients" });

	/** Hooks */
	const { t } = useTranslation();

	/** Functions */
	function handleOnDelete(index: number) {
		const currentRecipients = methods.getValues("recipients") || [];
		methods.setValue(
			"recipients",
			currentRecipients.filter((_, i) => i !== index),
		);
	}

	/** Render */
	return (
		<React.Fragment>
			{recipients.map((_, index) => (
				<div
					className="grid gap-x-4 items-end"
					key={index}
					style={{ gridTemplateColumns: "1fr max-content" }}
				>
					<TextInput
						control={methods.control}
						name={`recipients.${index}`}
						label={index === 0 ? t("personnel.fields.email") : undefined}
						isRequired
					/>
					<Button
						onClick={() => handleOnDelete(index)}
						variant="danger-ghost"
						icon={
							<Icon
								name="Trash2"
								className="stroke-red-500"
							/>
						}
						size="sm"
					/>
				</div>
			))}

			<TextInputAddTrigger
				methods={methods}
				path="recipients"
			/>
			<Divider
				variant="modal"
				className="my-4"
			/>
			<FormSwitch
				control={methods.control}
				name="sendCopyToCreator"
			>
				{t("partners.send_copy_to_myself")}
			</FormSwitch>
		</React.Fragment>
	);
}
